if (!customElements.get('wren-purchase-details')) {
  customElements.define('wren-purchase-details', class extends HTMLElement {
    connectedCallback() {
      this.model = JSON.parse(this.querySelector('[data-purchase-data]').textContent);
      this.productRoot = this.closest('product-info') || this.closest('.shopify-section');
      this.controller = new AbortController();
      this.queue = () => {
        clearTimeout(this.pending);
        this.pending = setTimeout(() => this.update(), 80);
      };
      for (const event of ['change', 'input', 'click']) {
        this.productRoot.addEventListener(event, this.queue, { capture: true, signal: this.controller.signal });
      }
      this.observer = new MutationObserver(records => {
        const relevant = records.some(record => {
          if (record.type === 'attributes') return record.target.matches('input[name="id"], input[name="selling_plan"]');
          return [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (
            node.matches('input[name="id"], input[name="selling_plan"]') || node.querySelector('input[name="id"], input[name="selling_plan"]')
          ));
        });
        if (relevant) this.queue();
      });
      this.observer.observe(this.productRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
          if (String(data?.sectionId) !== this.dataset.sectionId) return;
          const variantId = Number(data?.variant?.id);
          const productId = Number(this.dataset.productId);
          if (!Number.isSafeInteger(productId) || !this.model.variants.some(item => Number(item.id) === variantId)) return;

          const loop = window.LoopSubscriptions;
          const loopState = window.LOOP_WIDGET?.[productId];
          if (typeof loop?.handleLoopWidgetVariantIdChange === 'function' && loopState &&
              Number(loopState.selectedVariantId) !== variantId && !this.syncingLoop) {
            this.syncingLoop = true;
            try {
              loop.handleLoopWidgetVariantIdChange(productId, variantId);
            } catch (error) {
              console.warn('WrenLife could not synchronize subscription options.', error);
            } finally {
              this.syncingLoop = false;
            }
          }
          this.queue();
        });
      }
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.unsubscribe?.();
      clearTimeout(this.pending);
    }

    update() {
      const form = document.getElementById(this.dataset.formId);
      const variantId = form?.querySelector('input[name="id"]')?.value;
      const planId = form?.querySelector('input[name="selling_plan"]')?.value || '';
      const variant = this.model.variants.find(item => String(item.id) === variantId);
      const plan = variant?.plans.find(item => String(item.id) === planId);
      const valid = Boolean(variant && (!planId || plan));
      const unit = this.querySelector('[data-unit]');
      const terms = this.querySelector('[data-plan]');
      unit.hidden = !valid || !variant.servings;
      terms.hidden = !valid;
      this.querySelector('[data-subscription]').hidden = !plan;
      if (!valid) return;
      const unitText = plan ? plan.unit : variant.unit;
      const termsText = plan ? plan.terms : this.dataset.oneTime;
      if (unit.textContent !== unitText) unit.textContent = unitText;
      if (terms.textContent !== termsText) terms.textContent = termsText;
    }
  });
}
